import { render } from "./ExpiryInformation.vue?vue&type=template&id=66d3270c&scoped=true"
import script from "./ExpiryInformation.vue?vue&type=script&lang=js"
export * from "./ExpiryInformation.vue?vue&type=script&lang=js"

import "./ExpiryInformation.vue?vue&type=style&index=0&id=66d3270c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66d3270c"]])

export default __exports__